<template>
  <div :class="modal ? 'modal is-active': 'modal'">
    <div class="modal-background"></div>
    <div class="modal-card is-small">
      <header class="modal-card-head">
        <button class="delete" aria-label="close"></button>
        <p class="modal-card-title">Reset your Budler password</p>	
      </header>
      <section class="modal-card-body ph20">
        <p class="has-text-centered is-size-14 mb30">Please enter a new password for your account.</p>
        <form>
          <div class="field-group">
            <div class="field">
              <div class="control">
                <input class="input" type="email" placeholder="New Password">
            </div>
          </div>
          <div class="field">
              <div class="control">
                <input class="input" type="password" placeholder="Re-enter New Password">
            </div>
          </div>
        </div>
        </form>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-large bg-secondary text-white hover-opacity-7 is-full-width">Save Password</button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
 name: "ResetPasswordModal", // Not in use
  data() {
    return {
      modal: false,
    };
  },

  mounted() {
    bus.$on('show-modal-new-password-form', (payload) => {
      this.modal = payload;
    })
  },
  
  beforeDestroy() {
    bus.$off('show-modal-new-password-form');
  },

};
</script>